/**
 * T280 — Expense-comments API hooks.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { expenseCommentKeys } from './keys';
import { useActiveTenantId } from '../../hooks/useTenantContext';

export interface ExpenseCommentDto {
  id: string;
  expenseId: string;
  tenantId: string;
  authorUserId: string;
  authorRoleAtSave: string;
  body: string;
  createdAt: string;
}

export function useExpenseComments(expenseId: string | undefined) {
  const tenantId = useActiveTenantId();
  return useQuery({
    queryKey: expenseCommentKeys.forExpense(tenantId, expenseId!),
    queryFn: () =>
      api.get<{ items: ExpenseCommentDto[] }>(`/expenses/${expenseId}/comments`),
    enabled: !!expenseId && tenantId !== null,
  });
}

export function useCreateExpenseComment(expenseId: string) {
  const qc = useQueryClient();
  const tenantId = useActiveTenantId();
  return useMutation({
    mutationFn: (body: string) =>
      api.post<ExpenseCommentDto>(`/expenses/${expenseId}/comments`, { body }),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: expenseCommentKeys.forExpense(tenantId, expenseId) }),
  });
}
